import { post } from './api';

export const companyList = function (params) {
    return post('/userCompany/queryPaging', params);
};
export const companySave = function (params) {
    return post('/userCompany/save', params);
};
export const companyEdit = function (params) {
    return post('/userCompany/updateById', params);
};
export const companyInfo = function (params) {
    return post('/userCompany/getById', params);
};

export const getAddress = function (params) {
    return post('/userAddress/queryPaging', params);
};

export const addAddress = function (params) {
    return post('/userAddress/save', params);
};

export const updateAddress = function (params) {
    return post('/userAddress/updateById', params);
};

export const deleteAddress = function (params) {
    return post('/userAddress/removeByIds', params);
};

export const resetPassword = function (params) {
    return post('/userInfo/resetPassword', params);
};

export const getUserInfo = function () {
    return post('/userInfo/query');
};

export const setUserInfo = function (params) {
    return post('/userInfo/update', params);
};


export const getUserBookRecord = function (params) {
    return post('/userBook/queryRecordPaging', params);
};
